import { Dialog, DialogFooter, DialogType, PrimaryButton } from "@fluentui/react";
import React, { memo } from "react";
import { localize } from "src/l10n";
import PopupHeader from "../PopupHeader";

interface Props {
    message: string;
    show: boolean;
    onDismiss: any;
    title?: string;
}

export default memo(function InfoDialog(props: Props) {
    const { message, show, onDismiss, title } = props;
    const headerText = title || localize("Information");

    return (
        <Dialog
            hidden={!show}
            containerClassName="dialogWithPopupHeader"
            onDismiss={onDismiss}
            dialogContentProps={{
                type: DialogType.normal,
                title: headerText,
                closeButtonAriaLabel: localize("Stang"),
                subText: message,
            }}
            modalProps={{
                isBlocking: true,
                allowTouchBodyScroll: true
            }}
        >
            <PopupHeader
                text={headerText}
                subText={message}
                onClose={onDismiss} />
            <DialogFooter>
                <PrimaryButton
                    // theme={useContext(ThemeContext)}
                    onClick={() => {
                        onDismiss();
                    }}
                    text={localize("Ok")}
                />
            </DialogFooter>
        </Dialog>
    );
});
